import React from 'react'
import { TrophyMemoryCardLoading } from '~/modules/TrophyMemories/Infrastructure/Components/TrophyMemoryCardLoading'
import styles from './TrophyMemoriesLoading.module.scss'

interface Props {
  appearance?: 'default' | 'market'
}

export const TrophyMemoriesLoading: React.FC<Props> = ({ appearance = 'default' }) => {
  const numCards = 5

  const cards = Array.from(
    Array(numCards).keys()
  ).map((index) => <TrophyMemoryCardLoading key={ index }/>)

  return (
    <div
      className={ `
        ${styles.trophyMemoriesLoading__container}
        ${appearance === 'market' ? styles.trophyMemoriesLoading__container__market : ''}
      ` }
    >
      { cards }
    </div>
  )
}
